// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { HTMLColors } from '@Constants/colors';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

interface IsActionRequiredProps {
    value: boolean;
    onClick?: () => void;
    readOnly?: boolean;
}

export const IsActionRequired = ({ value, onClick, readOnly = false }: IsActionRequiredProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.WarningOutlined />}
            value={value}
            onClick={onClick}
            readOnly={readOnly}
            onTrue={{ color: HTMLColors.YELLOW, icon: <ICONS.WarningOutlined /> }}
            label={i('task.actionRequired.tooltip')}
        />
    );
};
